
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.13 10.053c0-.453.224-.851.566-1.096a2.221 2.221 0 00-1.017-.254 2.252 2.252 0 00-2.25 2.25c0 1.24 1.01 2.248 2.25 2.248 1.111 0 2.03-.81 2.212-1.87a1.342 1.342 0 01-1.762-1.278z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M15.244 10.652c-.137-.152-3.435-3.748-7.565-3.748-4.13 0-7.427 3.596-7.564 3.748a.45.45 0 000 .6c.137.153 3.434 3.749 7.564 3.749s7.428-3.596 7.565-3.748a.45.45 0 000-.6zm-7.565 3.449a3.153 3.153 0 01-3.15-3.149 3.153 3.153 0 013.15-3.148 3.153 3.153 0 013.15 3.149 3.153 3.153 0 01-3.15 3.148zM1.812 4.475l1.568.998 3.457-2.2a1.522 1.522 0 011.63 0l3.458 2.2 1.567-.998a.507.507 0 000-.853L7.924.079a.507.507 0 00-.544 0L1.812 3.622a.505.505 0 000 .853z","fill":"#E2E8F0"}})])
          )
        }
      }
    